import React from 'react'
import styled from 'styled-components'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Pagination, Scrollbar, A11y } from 'swiper'
SwiperCore.use([Pagination, Scrollbar, A11y])
import { createResource, useResource } from '@/lib/i18n'
import { Animation, Reveal } from 'react-genie'
import LazyLoad from 'react-lazyload'
import Link from 'next/link'
import Image from 'next/image'

const resource = createResource({
  en: {
    mainTitle: 'Why Borrow from Kredit Pintar',
    title1: 'Hilmalia Putri -  Tailor',
    title2: 'Dena Sofian -  Grape Farmer',
    title3: 'Eka Agus, Owner of Koh Eka Food Stall',
    desc1:
      `"I was able to build my fashion brand with a business capital loan from Kredit Pintar. The process was fast and easy. Kredit Pintar supported my first steps and my journey in growing the business."`,
    desc2:
      '"A loan from Kredit Pintar has helped support my grape farming business. Thank you, Kredit Pintar, for helping my vineyard continue to operate until today."',
    desc3: `"Kredit Pintar loans have helped make my business possible. I hope Kredit Pintar will continue to support the growth of my business in the future. I give a score of 10 out of 10 for my experience with Kredit Pintar.""`,
  },
  id: {
    mainTitle: 'Kenapa Pinjam Dana di Kredit Pintar',
    title1: 'Hilmalia Putri -  Penjahit',
    title2: 'Dena Sofian -  Petani Anggur',
    title3: 'Eka Agus, Pemilik Warung Koh Eka',
    desc1:
      '"Saya bisa membangun brand fashion dengan pinjaman untuk modal usaha dari Kredit Pintar. Prosesnya cepat dan mudah. Kredit Pintar membantu langkah awal dan perjalanan usaha saya."',
    desc2:
      '"Pinjaman Kredit Pintar membantu usaha pertanian anggur saya. Terima kasih Kredit Pintar sudah membantu perkebunan anggur saya tetap berjalan hingga saat ini."',
    desc3: `"Pinjaman Kredit Pintar bisa bantu mewujudkan usaha saya. Semoga nantinya Kredit Pintar bisa terus membantu pengembangan usaha saya ke depannya. Saya kasih nilai 10 dari 10 untuk pengalaman saya di Kredit Pintar."`,
  },
})

const Banner = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()
  const FeatureList = [
    {
      img: '/images/home/borrow20261.png',
      url: 'https://www.youtube.com/watch?v=0z1FaNMVrkg',
      title: t('title1'),
      desc: t('desc1'),
    },
    {
      img: '/images/home/borrow20262.png',
      url: 'https://www.youtube.com/watch?v=P8oKP7_-p_8',
      title: t('title2'),
      desc: t('desc2'),
    },
    {
      img: '/images/home/borrow20263.jpg',
      url: 'https://www.youtube.com/watch?v=9mPmJaFxTBg',
      title: t('title3'),
      desc: t('desc3'),
    },
  ]
  return (
    <Whys>
      <Link href={'/education'}>
        <a target="_blank" title={t('mainTitle')}>
          <h2 className="title">{t('mainTitle')}</h2>
        </a>
      </Link>
      <div className="items" style={{ width: width >= 1000 ? 'auto' : '360px' }}>
        {width >= 1000 ? (
          FeatureList.map((item, index) => (
            <div key={index} className="item">
              <div className="img">
                <Link href={item.url}>
                  <a target="_blank" title={item.title}>
                    <Reveal delay={200 + index * 150} animation={Animation.FadeIn}>
                      <Image src={item.img} alt={item.title} width={360} height={202.5} quality={85} placeholder="empty" />
                    </Reveal>
                  </a>
                </Link>
              </div>
              <div className="subtitle">{item.title}</div>
              <div className="desc">{item.desc}</div>
            </div>
          ))
        ) : (
          <Swiper loop={true} pagination={{ clickable: true }}>
            {FeatureList.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="item">
                  <div className="img">
                    <Link href={item.url}>
                      <a target="_blank" title={item.title}>
                        <LazyLoad>
                          <img src={item.img} alt={item.title} width={360} height={202.5} />
                        </LazyLoad>
                      </a>
                    </Link>
                  </div>
                  <div className="subtitle">{item.title}</div>
                  <div className="desc">{item.desc}</div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
    </Whys>
  )
}

export default Banner

const Whys = styled.div`
  @media only screen and (max-width: 1000px) {
    margin: 0 auto 20px;
    padding-top: 100px;
    text-align: center;
    width: 100%;
    .title {
      font-size: 24px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 28px;
      padding-bottom: 32px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      margin: 0 auto;
      .item {
        width: 288px;
        margin: 0 auto;
        text-align: left;
        .img {
          width: 100%;
          height: 180px;
          img {
            border-radius: 8px 8px 0px 0px;
          }
        }
        .desc {
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
          margin-bottom: 40px;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    padding: 90px 150px;
    text-align: center;
    width: 100%;
    max-width: 1440px;
    margin: 0 auto;

    .title {
      font-size: 36px;
      font-family: Roboto-Medium, Roboto;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.87);
      line-height: 48px;
      padding-bottom: 40px;
    }
    .items {
      display: flex;
      justify-content: space-between;
      .item {
        width: 360px;
        text-align: left;
        .img {
          width: 100%;
          height: 202.5px;
          img {
            border-radius: 8px 8px 0px 0px;
          }
        }
        .desc {
          width: 340px;
          font-size: 16px;
          font-family: Roboto-Regular, Roboto;
          font-weight: 400;
          color: #9e9e9e;
          line-height: 32px;
        }
      }
    }
  }
  img {
    width: 100%;
    height: 100%;
  }
  .subtitle {
    font-size: 24px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #333333;
    line-height: 32px;
    padding: 31px 0 20px;
  }
`
